import type { SVGProps } from 'react';

const ImageCountKeyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_174_45921)">
      <path
        d="M11.8405 17.6309L14.1952 15.2761C15.1226 14.3488 16.5855 14.2306 17.6497 14.9971V14.9971C18.8558 15.8657 20.5388 15.5845 21.3969 14.3709L23.8455 10.9078C25.2883 8.86733 28.3707 9.04647 29.5674 11.2404V11.2404"
        stroke="#112A55"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="17.6541"
        cy="7.5879"
        r="1.61378"
        stroke="#112A55"
        strokeLinejoin="round"
      />
      <rect
        x="11.476"
        y="0.5"
        width="18.024"
        height="21.4829"
        rx="4.68837"
        stroke="#112A55"
      />
      <path
        d="M8.16451 5.91655L4.27093 7.79641C1.69049 9.04227 0.608606 12.1441 1.85447 14.7245L7.11808 25.6266C8.36394 28.207 11.4658 29.2889 14.0462 28.043L17.9398 26.1632"
        stroke="#2563EB"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_174_45921">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ImageCountKeyIcon;
